// import React, { useEffect, useState } from "react";
// import { _Api, Api_form } from "../api/_call";
// import { useTranslation } from 'react-i18next';

// import { success, error } from "../common/helpers/toastify";
// import { set } from "react-hook-form";
// const ProductImportExportModel = (props) => {
//   const { t } = useTranslation();
//   const { master_product_checkbox_value, getProductExportList, setGetProductExportList } = props;
//   const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;

//   const [importfile, setImportfile] = useState('');
//   const [importmesssage, setImportMessage] = useState();
//   const [exportmesssage, setExportMessage] = useState();
//   const [checkedProduct, setProduct] = useState(false);
//   const [checkedVariants, setVariants] = useState(false);
//   const [checkedReorder, setReorder] = useState(false);
//   const [checkedPricing, setPricing] = useState(false);
//   const [checkedChoice, setChoice] = useState(false);
//   const [btnexport,setBtnExport] = useState(false);
//   const [productexportList, setProductexportList] = useState([]);
//   const handleClickProduct = () => setProduct(!checkedProduct);
//   const handleClickVariants = () => setVariants(!checkedVariants);
//   const handleClickReorder = () => setReorder(!checkedReorder);
//   const handleClickPricing = () => setPricing(!checkedPricing);
//   const handleClickChoice = () => setChoice(!checkedChoice);



//   const readExcel = async () => {
//     if(btnexport){
//       setImportMessage("File Already uploading please wait")
//       return;
//     }
//     setImportMessage("Please wait file is uploading...");
//     try {
//        setBtnExport(true);
//       const formData = new FormData();
//       formData.append("file", importfile);
//       formData.append("type", "ProductImport");
//       let res = await Api_form(formData, `api/v1/App/productimport/uploadXls`);
//       if (res.code === 200) {
//         setImportMessage("");
//         success((res.message));
//         setFile([]);
//         setBtnExport(false);
//       } else {
//         setImportMessage("Please Wait or try again later!!");
//         error((res.message));
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   const exportProduct = async () => {
//     var checked_ids = master_product_checkbox_value;
//     try {
//       var checkedProduct_val = checkedProduct === true ? 1 : 0;
//       var checkedVariants_val = checkedVariants === true ? 1 : 0;
//       var checkedReorder_val = checkedReorder === true ? 1 : 0;
//       var checkedPricing_val = checkedPricing === true ? 1 : 0;
//       var checkedChoice_val = checkedChoice === true ? 1 : 0;
//       const postData = {
//         "type": "Productexport",
//         "product": checkedProduct_val,
//         "variants": checkedVariants_val,
//         "reorder": checkedReorder_val,
//         "pricing": checkedPricing_val,
//         "key": checked_ids,
//         "choice": checkedChoice_val
//       }
//       let res = await _Api(postData, `api/v1/App/productexport/createExport`);
//       if (res.code === 200) {
//         success((res.message));
//         setImportMessage("");
//         setFile([]);
//         setProduct(false);
//         setVariants(false);
//         setReorder(false);
//         setPricing(false);
//         setChoice(false);
//         setBtnExport(false);
//         setImportfile('');
//       } else {
//         setExportMessage("Please Wait or try again later!!");
//         error((res.message));

//       }
//     } catch (err) {
//       console.log(err, "err");
//       error(err);

//     }
//   };
//   const getExportList = async () => {

//     try {

//       var postdata = { "type": "Productexport" }
//       let res = await _Api(postdata, `api/v1/App/productexport/getList`);
//       if (res.code === 200) {
//         setProductexportList(res.data);
//         console.log(productexportList, "productexportlist")
//         setGetProductExportList(false);
//       } 
//     } catch (err) {
//       console.log(err, "err");
//       setGetProductExportList(false);
//     }
//   };
//   useEffect(() => {
//     if(getProductExportList){
//     getExportList();
//     }
//   // eslint-disable-next-line
//   }, [getProductExportList]);

//   const [file, setFile] = React.useState([]);
//   const handleUpload = (event) => {
//     setFile((file) => [...file, event.target.files[0]]);
//   }


//   return (
//     <div
//       className="modal fade import-export-modal"
//       id="productImportExportModel_data"
//       tabIndex={-1}
//       aria-labelledby="productModalLabel"
//       aria-hidden="true"
//     >
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content">
//           <div className="modal-header">
//             <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"onClick={()=>{
//               setImportMessage("");
//               setExportMessage("");
//               setFile([]);
//               setProduct(false);
//               setVariants(false);
//               setReorder(false);
//               setPricing(false);
//               setChoice(false);
//               setBtnExport(false);
//               setImportfile('');
//             }}></button>
//           </div>
//           <div className="modal-body import-export-modal-row">
//             <div className="import-export-modal-row-box">
//               <h4 className="import-export-modal-row-box-heading">{t("Product Import")}</h4>
//               <div className="filter-modal-row-box-content">
//                 <div className="modal-content">
//                   <div className="upload-msg">{importmesssage ? importmesssage : ""}</div>
//                   <div className='import-modal-choose-file'>
//                     {t("choose file")}
//                     <input
//                       type="file"
//                       name="files"
//                       onChange={(e) => {
//                         const file = e.target.files[0];
//                         setImportfile(file);
//                         handleUpload(e);
//                       }}
//                       accept=".xlsx, .xls"

//                     />
//                   </div>
//                   <label className="import-modal-choose-file-name">{file[0]?.name}</label>

//                   <div className="modal-footer">
//                     <button
//                       type="button"
//                       onClick={readExcel}
//                       className="btn com-btn modal-content-yes"
//                       disabled={btnexport}
//                     >
//                       {t("Submit")}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="import-export-modal-row-box">
//               <h4 className="import-export-modal-row-box-heading">{t("Product Export")}</h4>
//               <div className="filter-modal-row-box-content">
//                 <div className="upload-msg">{exportmesssage ? t(exportmesssage) : ""}</div>
//                 <div className="checkbox-row">
//                   <div className="checkbox checkbox-custom checkbox-row-single">

//                     <div className="com-check" id="">
//                       <input
//                         type="checkbox"
//                         id="Product"
//                         checked={checkedProduct ? 'checked' : ''}
//                         onChange={() => handleClickProduct()}
//                       />
//                       <label htmlFor="Product" className="com-check-label"></label>
//                     </div>
//                     <label
//                       className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
//                       htmlFor="Product"
//                     >
//                       {t("Product")}
//                     </label>
//                   </div>
//                   <div className="checkbox checkbox-custom checkbox-row-single">
//                     <div className="com-check" id="">
//                       <input
//                         type="checkbox"
//                         id="Variants"
//                         checked={checkedVariants ? 'checked' : ''}
//                         onChange={() => handleClickVariants()}
//                       />
//                       <label htmlFor="Variants" className="com-check-label"></label>
//                     </div>
//                     <label
//                       className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
//                       htmlFor="Variants"
//                     >
//                       {t("Variants")}
//                     </label>
//                   </div>
//                   <div className="checkbox checkbox-custom checkbox-row-single">
//                     <div className="com-check" id="">
//                       <input
//                         type="checkbox"
//                         id="Reorder"
//                         checked={checkedReorder ? 'checked' : ''}
//                         onChange={() => handleClickReorder()}
//                       />
//                       <label htmlFor="Reorder" className="com-check-label"></label>
//                     </div>
//                     <label
//                       className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
//                       htmlFor="Reorder"
//                     >
//                       {t("Reorder")}
//                     </label>
//                   </div>
//                   <div className="checkbox checkbox-custom checkbox-row-single">
//                     <div className="com-check" id="">
//                       <input
//                         type="checkbox"
//                         id="Pricing"
//                         checked={checkedPricing ? 'checked' : ''}
//                         onChange={() => handleClickPricing()}
//                       />
//                       <label htmlFor="Pricing" className="com-check-label"></label>
//                     </div>
//                     <label
//                       className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
//                       htmlFor="Pricing"
//                     >
//                       {t("Pricing")}
//                     </label>
//                   </div>
//                   <div className="checkbox checkbox-custom checkbox-row-single">
//                     <div className="com-check" id="">
//                       <input
//                         type="checkbox"
//                         id="Choice"
//                         checked={checkedChoice ? 'checked' : ''}
//                         onChange={() => handleClickChoice()}
//                       />
//                       <label htmlFor="Choice" className="com-check-label"></label>
//                     </div>

//                     <label
//                       className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
//                       htmlFor="Choice"
//                     >
//                       {t("Choice")}
//                     </label>
//                   </div>
//                 </div>
//                 <div className="modal-footer">
//                   <button
//                     type="button"
//                     onClick={() => exportProduct()}
//                     data-bs-dismiss="modal"
//                     className="btn com-btn modal-content-yes"
//                   >
//                     {t("Export Request")}
//                   </button>
//                 </div>
//                 <div className="dropdown product-edit-detail">
//                   <button
//                     className="btn btn-secondary dropdown-toggle product-edit-detail-btn"
//                     type="button"
//                     id="dropdownMenuButton1"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                   >
//                     <img src={base_assets + "images/icons/note-board-icon-dark.png"} alt="" />
//                   </button>
//                   <ul
//                     className="dropdown-menu"
//                     aria-labelledby="dropdownMenuButton1"
//                   >
//                     <li className="mb-2">{t("LIst Export Complete Your Data")}</li>
//                     {productexportList.map((ele, index) => {
//                       return (
//                         <li className="dropdown-menu-detail-single" key={index}>
//                           <a
//                             className="dropdown-menu-detail-single-time"
//                             href={ele.filepath} download=''
//                           >
//                             <span className="date">{ele.date}</span>
//                           </a>
//                           <span><i className="fa fa-user" aria-hidden="true"></i> {ele.name}</span>
//                         </li>)
//                     })}
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductImportExportModel;


import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { _Api, Api_form } from "../api/_call";
import { useTranslation } from 'react-i18next';

import { success, error } from "../common/helpers/toastify";
import { set } from "react-hook-form";
const ProductImportExportModel = (props) => {
  const { t } = useTranslation();
  const { master_product_checkbox_value, getProductExportList, setGetProductExportList } = props;
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;

  const [importConfirm, setImportConfirm] = useState(null);
  const [importfile, setImportfile] = useState('');
  const [importFiles, setImportFiles] = useState([]);
  const [importmesssage, setImportMessage] = useState();
  const [exportmesssage, setExportMessage] = useState();
  const [checkedProduct, setProduct] = useState(false);
  const [checkedVariants, setVariants] = useState(false);
  const [checkedReorder, setReorder] = useState(false);
  const [checkedPricing, setPricing] = useState(false);
  const [checkedChoice, setChoice] = useState(false);
  const [btnexport,setBtnExport] = useState(false);
  const [productexportList, setProductexportList] = useState([]);
  const [exportFormat, setExportFormat] = useState("xlsx");
  const handleClickProduct = () => setProduct(!checkedProduct);
  const handleClickVariants = () => setVariants(!checkedVariants);
  const handleClickReorder = () => setReorder(!checkedReorder);
  const handleClickPricing = () => setPricing(!checkedPricing);
  const handleClickChoice = () => setChoice(!checkedChoice);
  const allExportSelected =
    checkedProduct && checkedVariants && checkedReorder && checkedPricing && checkedChoice;
  const handleClickAllExport = () => {
    const next = !allExportSelected;
    setProduct(next);
    setVariants(next);
    setReorder(next);
    setPricing(next);
    setChoice(next);
  };

  const getSelectedFiles = () =>
    importFiles?.length ? importFiles : importfile ? [importfile] : [];

  const countSkuRows = (rows = []) => {
    const headerIndex = rows.findIndex(
      (row) =>
        Array.isArray(row) &&
        row.some((cell) => String(cell ?? "").trim().toLowerCase() === "sku")
    );
    if (headerIndex < 0) return 0;
    const skuIndex = rows[headerIndex].findIndex(
      (cell) => String(cell ?? "").trim().toLowerCase() === "sku"
    );
    return rows
      .slice(headerIndex + 1)
      .filter((row) => String(row?.[skuIndex] ?? "").trim() !== "").length;
  };

  const countProductsInFile = async (file) => {
    const name = String(file?.name || "").toLowerCase();
    const workbook = name.endsWith(".csv")
      ? XLSX.read(await file.text(), { type: "string" })
      : XLSX.read(await file.arrayBuffer(), { type: "array" });
    const sheetName =
      workbook.SheetNames.find((sheet) => sheet.toLowerCase() === "product") ||
      workbook.SheetNames[0];
    if (!sheetName) return 0;
    return countSkuRows(
      XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1, defval: "" })
    );
  };

  const askToProceed = async () => {
    const filesToUpload = getSelectedFiles();
    if (!filesToUpload.length) {
      error(t("Please choose a file"));
      return;
    }
    try {
      let total = 0;
      for (const file of filesToUpload) {
        total += await countProductsInFile(file);
      }
      setImportMessage("");
      setImportConfirm({
        total,
        message: t("This file has {{total}} products. Do you want to proceed?", {
          total,
        }),
      });
    } catch (err) {
      console.log(err, "err");
      error(t("Please choose a file"));
    }
  };

  const readExcel = async () => {
    if(btnexport){
      setImportMessage("File Already uploading please wait")
      return;
    }
    const filesToUpload = getSelectedFiles();
    if (!filesToUpload.length) {
      error(t("Please choose a file"));
      return;
    }
    setImportMessage("Please wait file is uploading...");
    try {
       setBtnExport(true);
      const formData = new FormData();
      filesToUpload.forEach((f) => {
        formData.append("file", f);
      });
      formData.append("type", "ProductImport");
      let res = await Api_form(formData, `api/v1/App/productimport/uploadXlsOptimized`);
      if (res.code === 200) {
        const count = importConfirm?.total;
        setImportConfirm(null);
        setImportMessage("");
        setFile([]);
        setImportFiles([]);
        setImportfile('');
        setBtnExport(false);
        // success(
        //   count
        //     ? t("Import started for {{count}} products. The process is running in the background. Please wait a few minutes.", { count })
        //     : t("Import started. The process is running in the background. Please wait a few minutes.")
        // );
        success(res?.message||t("Import started. The process is running in the background. Please wait a few minutes."))
        window.dispatchEvent(new CustomEvent("gis-product-import", {
          detail: {
            status: "running",
            label: "Product import",
            done: 0,
            total: Number(res?.total_rows || res?.import_rows || count || 0),
          },
        }));
        const importEl = document.getElementById("productImportExportModel_data");
        if (importEl && window.bootstrap?.Modal) {
          window.bootstrap.Modal.getOrCreateInstance(importEl).hide();
        }
      } else {
        setImportMessage("Please Wait or try again later!!");
        error((res.message));
        setBtnExport(false);
      }
    } catch (err) {
      console.log(err, "err");
      setBtnExport(false);
    }
  };

  const exportProduct = async () => {
    var checked_ids = master_product_checkbox_value;
    try {
      var checkedProduct_val = checkedProduct === true ? 1 : 0;
      var checkedVariants_val = checkedVariants === true ? 1 : 0;
      var checkedReorder_val = checkedReorder === true ? 1 : 0;
      var checkedPricing_val = checkedPricing === true ? 1 : 0;
      var checkedChoice_val = checkedChoice === true ? 1 : 0;
      const postData = {
        "type": "Productexport",
        "product": checkedProduct_val,
        "variants": checkedVariants_val,
        "reorder": checkedReorder_val,
        "pricing": checkedPricing_val,
        "key": checked_ids,
        "choice": checkedChoice_val,
        "format": exportFormat || "xlsx",
      }
      let res = await _Api(postData, `api/v1/App/productexport/createExport`);
      if (res.code === 200) {
        success((res.message));
        setImportMessage("");
        setFile([]);
        setProduct(false);
        setVariants(false);
        setReorder(false);
        setPricing(false);
        setChoice(false);
        setBtnExport(false);
        setImportfile('');
        setExportFormat("xlsx");
      } else {
        setExportMessage("Please Wait or try again later!!");
        error((res.message));

      }
    } catch (err) {
      console.log(err, "err");
      error(err);

    }
  };
  const getExportList = async () => {

    try {

      var postdata = { "type": "Productexport" }
      let res = await _Api(postdata, `api/v1/App/productexport/getList`);
      if (res.code === 200) {
        setProductexportList(res.data);
        console.log(productexportList, "productexportlist")
        setGetProductExportList(false);
      } 
    } catch (err) {
      console.log(err, "err");
      setGetProductExportList(false);
    }
  };
  useEffect(() => {
    if(getProductExportList){
    getExportList();
    }
  // eslint-disable-next-line
  }, [getProductExportList]);

  const [file, setFile] = React.useState([]);
  const handleUpload = (event) => {
    const selected = Array.from(event.target.files || []);
    setFile(selected);
  }


  return (
    <div
      className="modal fade import-export-modal"
      id="productImportExportModel_data"
      tabIndex={-1}
      aria-labelledby="productModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"onClick={()=>{
              setImportMessage("");
              setImportConfirm(null);
              setExportMessage("");
              setFile([]);
              setProduct(false);
              setVariants(false);
              setReorder(false);
              setPricing(false);
              setChoice(false);
              setBtnExport(false);
              setImportfile('');
              setImportFiles([]);
              setExportFormat("xlsx");
            }}></button>
          </div>
          <div className="modal-body import-export-modal-row">
            <div className="import-export-modal-row-box">
              <h4 className="import-export-modal-row-box-heading">{t("Product Import")}</h4>
              <div className="filter-modal-row-box-content">
                <div className="modal-content">
                  <div className="upload-msg">{importmesssage ? importmesssage : ""}</div>
                  <div className='import-modal-choose-file'>
                    {t("choose file")}
                    <input
                      type="file"
                      name="files"
                      multiple
                      onChange={(e) => {
                        const selected = Array.from(e.target.files || []);
                        setImportFiles(selected);
                        setImportfile(selected[0] || "");
                        setImportConfirm(null);
                        handleUpload(e);
                      }}
                      accept=".xlsx, .xls, .csv"

                    />
                  </div>
                  <label className="import-modal-choose-file-name">
                    {importFiles?.length
                      ? importFiles.map((f) => f.name).join(", ")
                      : file[0]?.name}
                  </label>

                  {importConfirm ? (
                    <div className="upload-msg">
                      <p style={{ margin: "12px 0 20px", color: "#2A2A2A", fontSize: "15px" }}>{importConfirm.message}</p>
                      <div className="modal-footer" style={{ marginTop: "8px", gap: "16px" }}>
                        <button
                          type="button"
                          className="btn com-btn"
                          disabled={btnexport}
                          onClick={() => {
                            setImportConfirm(null);
                            setImportMessage("");
                          }}
                        >
                          {t("No")}
                        </button>
                        <button
                          type="button"
                          className="btn com-btn modal-content-yes"
                          disabled={btnexport}
                          onClick={() => readExcel()}
                        >
                          {t("Yes")}
                        </button>
                      </div>
                    </div>
                  ) : (
                  <div className="modal-footer">
                    <button
                      type="button"
                      onClick={() => askToProceed()}
                      className="btn com-btn modal-content-yes"
                      disabled={btnexport}
                    >
                      {t("Submit")}
                    </button>
                  </div>
                  )}
                </div>
              </div>
            </div>
            <div className="import-export-modal-row-box">
              <h4 className="import-export-modal-row-box-heading">{t("Product Export")}</h4>
              <div className="filter-modal-row-box-content">
                <div className="upload-msg">{exportmesssage ? t(exportmesssage) : ""}</div>
                <div className="checkbox-row">
                  <div className="checkbox checkbox-custom checkbox-row-single">
                    <div className="com-check" id="">
                      <input
                        type="checkbox"
                        id="ExportAll"
                        checked={allExportSelected ? "checked" : ""}
                        onChange={() => handleClickAllExport()}
                      />
                      <label htmlFor="ExportAll" className="com-check-label"></label>
                    </div>
                    <label
                      className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
                      htmlFor="ExportAll"
                    >
                      {t("All")}
                    </label>
                  </div>
                  <div className="checkbox checkbox-custom checkbox-row-single">

                    <div className="com-check" id="">
                      <input
                        type="checkbox"
                        id="Product"
                        checked={checkedProduct ? 'checked' : ''}
                        onChange={() => handleClickProduct()}
                      />
                      <label htmlFor="Product" className="com-check-label"></label>
                    </div>
                    <label
                      className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
                      htmlFor="Product"
                    >
                      {t("Product")}
                    </label>
                  </div>
                  <div className="checkbox checkbox-custom checkbox-row-single">
                    <div className="com-check" id="">
                      <input
                        type="checkbox"
                        id="Variants"
                        checked={checkedVariants ? 'checked' : ''}
                        onChange={() => handleClickVariants()}
                      />
                      <label htmlFor="Variants" className="com-check-label"></label>
                    </div>
                    <label
                      className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
                      htmlFor="Variants"
                    >
                      {t("Variants")}
                    </label>
                  </div>
                  <div className="checkbox checkbox-custom checkbox-row-single">
                    <div className="com-check" id="">
                      <input
                        type="checkbox"
                        id="Reorder"
                        checked={checkedReorder ? 'checked' : ''}
                        onChange={() => handleClickReorder()}
                      />
                      <label htmlFor="Reorder" className="com-check-label"></label>
                    </div>
                    <label
                      className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
                      htmlFor="Reorder"
                    >
                      {t("Reorder")}
                    </label>
                  </div>
                  <div className="checkbox checkbox-custom checkbox-row-single">
                    <div className="com-check" id="">
                      <input
                        type="checkbox"
                        id="Pricing"
                        checked={checkedPricing ? 'checked' : ''}
                        onChange={() => handleClickPricing()}
                      />
                      <label htmlFor="Pricing" className="com-check-label"></label>
                    </div>
                    <label
                      className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
                      htmlFor="Pricing"
                    >
                      {t("Pricing")}
                    </label>
                  </div>
                  <div className="checkbox checkbox-custom checkbox-row-single">
                    <div className="com-check" id="">
                      <input
                        type="checkbox"
                        id="Choice"
                        checked={checkedChoice ? 'checked' : ''}
                        onChange={() => handleClickChoice()}
                      />
                      <label htmlFor="Choice" className="com-check-label"></label>
                    </div>

                    <label
                      className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
                      htmlFor="Choice"
                    >
                      {t("Choice")}
                    </label>
                  </div>
                </div>
                <div className="mt-2 mb-2">
                  <label className="mb-1 d-block">{t("Export format")}</label>
                  <div className="d-flex gap-3 flex-wrap">
                    <label className="d-flex align-items-center gap-1">
                      <input
                        type="radio"
                        name="productExportFormat"
                        value="xlsx"
                        checked={exportFormat === "xlsx"}
                        onChange={() => setExportFormat("xlsx")}
                      />
                      {t("Excel (.xlsx)")}
                    </label>
                    <label className="d-flex align-items-center gap-1">
                      <input
                        type="radio"
                        name="productExportFormat"
                        value="csv"
                        checked={exportFormat === "csv"}
                        onChange={() => setExportFormat("csv")}
                      />
                      {t("CSV")}
                    </label>
                  </div>
                  {exportFormat === "csv" ? (
                    <small className="text-muted d-block mt-1">
                      {t("One sheet downloads as .csv. Multiple sheets download as a .zip of CSV files.")}
                    </small>
                  ) : null}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    onClick={() => exportProduct()}
                    data-bs-dismiss="modal"
                    className="btn com-btn modal-content-yes"
                  >
                    {t("Export Request")}
                  </button>
                </div>
                <div className="dropdown product-edit-detail">
                  <button
                    className="btn btn-secondary dropdown-toggle product-edit-detail-btn"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src={base_assets + "images/icons/note-board-icon-dark.png"} alt="" />
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li className="mb-2">{t("LIst Export Complete Your Data")}</li>
                    {productexportList.map((ele, index) => {
                      return (
                        <li className="dropdown-menu-detail-single" key={index}>
                          <a
                            className="dropdown-menu-detail-single-time"
                            href={ele.filepath} download=''
                          >
                            <span className="date">{ele.date}</span>
                          </a>
                          <span><i className="fa fa-user" aria-hidden="true"></i> {ele.name}</span>
                        </li>)
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductImportExportModel;
